module.exports = __webpack_public_path__ + "img/sample_jianyanbaogao2.b8d309cb.png";